import type { CSSProperties } from 'react';

import { PauseCircle, PlayCircle } from '@phosphor-icons/react/dist/ssr';
import { useSpinDelay } from 'spin-delay';

import * as styles from './AudioPlayer.css';

interface Props {
  isPlaying: boolean;
  isBuffering: boolean;
  playButtonSize: number;
  iconColor: CSSProperties['color'];
  onPlayAttempt?: () => void;
  isPlaybackLocked?: boolean;
  isReady: boolean;
  togglePlay: () => void;
}

const PlayButton = ({
  isReady,
  isPlaybackLocked,
  isPlaying,
  isBuffering,
  playButtonSize,
  iconColor,
  togglePlay,
  onPlayAttempt,
}: Props) => {
  const Icon = isPlaying || isBuffering ? PauseCircle : PlayCircle;
  const showSpinner = useSpinDelay(isBuffering, { delay: 300, minDuration: 500 });

  return (
    <button
      type="button"
      className={styles.controlButton}
      onClick={onPlayAttempt ?? togglePlay}
      disabled={onPlayAttempt ? false : !isReady || isPlaybackLocked}
      aria-label={isPlaying ? 'Pause' : isBuffering ? 'Loading' : 'Play'}
    >
      <span className={styles.playButtonWrapper} style={{ color: iconColor }}>
        <Icon size={playButtonSize} weight="fill" color={iconColor} />
        {showSpinner && <span className={styles.spinnerOverlay} />}
      </span>
    </button>
  );
};

export default PlayButton;
